import { Button, Grid, Paper } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import Appbar from './Appbar'
import Sidebar from './Sidebar'
import "../Assets/CSS/Dashboard.css"
import { useLocation } from 'react-router-dom'
import Web3 from 'web3'

const Dashboard = () => {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [userId, setUserId] = useState("");
    const [userData, setUserData] = useState(null);
    const location = useLocation();
    const [copied, setCopied] = useState(false);
    const [chiValue, setChiValue] = useState(0);
    const [bccprice, setBccPrice] = useState(0);
    const [bccsupply, setBccSupply] = useState(0);
    const [token, setToken] = useState(0);
    const [liqudity, setLiqudity] = useState(0);
    const [levelWallet, setLevelWallet] = useState(0);
    const [liveRate, setLiveRate] = useState(0);
    const [downlineTeam, setDownlineTeam] = useState(0);
    const [downlineBusiness, setDownlineBusiness] = useState(0);
    const dataFetchedRef = useRef(false);

    const walletAddress =
        location.state?.wallet || localStorage.getItem("walletAddress");

    const tokenAddress = "0x7c96F64a8427dE1F68eceb221E79d4DD2E8d0744";

    const [web3Instance, setWeb3Instance] = useState(null);

    const tokenABI = [{ "inputs": [{ "internalType": "address", "name": "_a1", "type": "address" }, { "internalType": "address", "name": "_a2", "type": "address" }, { "internalType": "address", "name": "_a3", "type": "address" }, { "internalType": "address", "name": "_a4", "type": "address" }, { "internalType": "address", "name": "_a5", "type": "address" }], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "user", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "usdt", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "tokens", "type": "uint256" }], "name": "Buy", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "user", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "claimId", "type": "uint256" }], "name": "LevelIncomeClaimed", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "user", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "usdt", "type": "uint256" }], "name": "LevelReward", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "user", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "tokens", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "usdt", "type": "uint256" }], "name": "Sell", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "inputs": [], "name": "AwardFundT", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "BuyBNBConnect", "outputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "stateMutability": "payable", "type": "function" }, { "inputs": [], "name": "ExpenseFund", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "ExpenseWallet", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "GetExpense", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "GetRoyalty", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "ITFundT", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "LC", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "LP", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "LegalFundT", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "name": "LevelCountribution", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "LevelFund", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "LevelIncomeWallet", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "name": "LevelMemberCount", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "Liqudity", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "MarketingFundT", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "OnOffBuy", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "RoyaltyB", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "RoyaltyWalletC", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "_owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "addressToUserId", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "bcc_Price", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "buyId", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "buyRecord", "outputs": [{ "internalType": "address", "name": "cust_address", "type": "address" }, { "internalType": "uint256", "name": "bnb_amt", "type": "uint256" }, { "internalType": "uint256", "name": "bbcPrice", "type": "uint256" }, { "internalType": "uint256", "name": "token_to_user", "type": "uint256" }, { "internalType": "uint256", "name": "distribution_amt", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "claimLevelIncome", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "customerId", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "distribute_level", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }], "name": "getUserBuyRecords", "outputs": [{ "components": [{ "internalType": "address", "name": "cust_address", "type": "address" }, { "internalType": "uint256", "name": "bnb_amt", "type": "uint256" }, { "internalType": "uint256", "name": "bbcPrice", "type": "uint256" }, { "internalType": "uint256", "name": "token_to_user", "type": "uint256" }, { "internalType": "uint256", "name": "distribution_amt", "type": "uint256" }], "internalType": "struct BnbConnectToken.Buyhistory[]", "name": "", "type": "tuple[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }], "name": "getUserSellCount", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }, { "internalType": "uint256", "name": "index", "type": "uint256" }], "name": "getUserSellDetails", "outputs": [{ "internalType": "uint256", "name": "token", "type": "uint256" }, { "internalType": "uint256", "name": "bnbAmount", "type": "uint256" }, { "internalType": "uint256", "name": "adminFee", "type": "uint256" }, { "internalType": "uint256", "name": "finalAmount", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "isBuyPause", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "isRegistered", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "levelClaimId", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "levelClaimRecord", "outputs": [{ "internalType": "address", "name": "user", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "time", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "payoutPercent", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "refer_address", "type": "address" }], "name": "register", "outputs": [{ "internalType": "uint256", "name": "custid", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "tokenAmount", "type": "uint256" }], "name": "sellBCC", "outputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "sellId", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "sellRecord", "outputs": [{ "internalType": "address", "name": "cust_address", "type": "address" }, { "internalType": "uint256", "name": "token", "type": "uint256" }, { "internalType": "uint256", "name": "bnb_amt", "type": "uint256" }, { "internalType": "uint256", "name": "admin_amt", "type": "uint256" }, { "internalType": "uint256", "name": "final_amt", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalCollection", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "totalLevelIncome", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalMint", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "name": "userLevelClaimIds", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "userRegister", "outputs": [{ "internalType": "address", "name": "customer_address", "type": "address" }, { "internalType": "address", "name": "referral_address", "type": "address" }, { "internalType": "uint256", "name": "totalDeposit", "type": "uint256" }, { "internalType": "uint256", "name": "totalSellBnb", "type": "uint256" }, { "internalType": "uint256", "name": "level_income", "type": "uint256" }, { "internalType": "uint256", "name": "totalbnbcSell", "type": "uint256" }, { "internalType": "uint256", "name": "directCount", "type": "uint256" }, { "internalType": "uint256", "name": "directBusiness", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "name": "userSellIds", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }]

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

const getWeb3 = () => {
    const provider = window.ethereum || window.trustwallet || 
                     window.tokenpocket || window.coin98;
    
    if (provider) {
        return { web3: new Web3(provider), provider };
    }
    
    // ✅ publicnode use karo
    const rpc = new Web3(
        new Web3.providers.HttpProvider("https://bsc-rpc.publicnode.com")
    );
    return { web3: rpc, provider: null };
};

const getUserData = async () => {
    try {
        if (!walletAddress) return;

        // ✅ Sirf RPC use karo - provider se nahi
        const web3 = new Web3(
            new Web3.providers.HttpProvider("https://bsc-rpc.publicnode.com")
        );
        setWeb3Instance(web3);

        const contract = new web3.eth.Contract(tokenABI, tokenAddress);
        
        let checksumAddress;
        try {
            checksumAddress = web3.utils.toChecksumAddress(walletAddress);
        } catch(e) {
            checksumAddress = walletAddress;
        }

        const id = await contract.methods
            .addressToUserId(checksumAddress).call();
        setUserId(id.toString());
        localStorage.setItem("userId", id.toString());

        if (Number(id) === 0) return;

        const data = await contract.methods
            .userRegister(Number(id)).call();
        
        const safeData = Object.fromEntries(
            Object.entries(data).map(([key, value]) => [
                key,
                typeof value === "bigint" ? value.toString() : value
            ])
        );
        setUserData(safeData);
        localStorage.setItem("userData", JSON.stringify(safeData));

        const calculatedChi = (Number(safeData.totalDeposit) * 2).toString();
        setChiValue(calculatedChi);

        const bccPrice = await contract.methods.bcc_Price().call();
        setBccPrice(bccPrice.toString());

        const bccSupply = await contract.methods.totalSupply().call();
        setBccSupply(bccSupply.toString());

        const tokenBal = await contract.methods
            .balanceOf(checksumAddress).call();
        setToken(tokenBal.toString());

        const liq = await contract.methods.Liqudity().call();
        setLiqudity(liq.toString());

        const levelIncome = await contract.methods
            .LevelIncomeWallet(checksumAddress).call();
        setLevelWallet(levelIncome.toString());

        // CoinGecko
        try {
            const response = await fetch(
                "https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd"
            );
            const priceData = await response.json();
            const bnbPriceUSD = Number(priceData.binancecoin.usd);
            const bccPriceEth = parseFloat(
                web3.utils.fromWei(bccPrice.toString(), "ether")
            );
            setLiveRate((bnbPriceUSD * bccPriceEth).toString());
        } catch (e) {
            console.warn("CoinGecko failed:", e.message);
            setLiveRate("0");
        }

        // Level members
        const promises = [];
        for (let i = 1; i <= 15; i++) {
            promises.push(
                contract.methods
                    .LevelMemberCount(checksumAddress, i).call()
            );
        }
        const results = await Promise.all(promises);
        const totalLevelMembers = results.reduce(
            (sum, val) => sum + Number(val), 0
        );
        setDownlineTeam(totalLevelMembers);

        // Downline business
        const cachedContribution = localStorage.getItem("downlineBusiness");
        if (cachedContribution) {
            setDownlineBusiness(Number(cachedContribution));
        } else {
            let totalContribution = 0;
            for (let i = 1; i <= 15; i++) {
                const val = await contract.methods
                    .LevelCountribution(checksumAddress, i).call();
                totalContribution += Number(val);
                await new Promise(r => setTimeout(r, 300));
            }
            setDownlineBusiness(totalContribution);
            localStorage.setItem("downlineBusiness", totalContribution);
        }

    } catch (error) {
        console.error("Dashboard Error:", error);
        alert("Data load error: " + error.message);
    }
};

    const convertWeiToEther = (value) => {
    if (!value || value === "0" || value === undefined) return "0";
    try {
        const Web3Utils = new Web3(
            new Web3.providers.HttpProvider("https://bsc-dataseed.binance.org/")
        );
        return parseFloat(
            Web3Utils.utils.fromWei(value.toString(), "ether")
        ).toFixed(6);
    } catch (e) {
        return "0";
    }
};

    const handleCopy = async () => {
        try {
            const link = `https://bnbconnect.io/Registration?id=${walletAddress}`;

            await navigator.clipboard.writeText(link);

            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 3000);

        } catch (error) {
            console.error("Copy failed:", error);
        }
    };

    // ✅ Mobile ke liye delay add karo
useEffect(() => {
    const savedId = localStorage.getItem("userId");
    const savedData = localStorage.getItem("userData");

    if (savedId && savedData) {
        setUserId(savedId);
        setUserData(JSON.parse(savedData));
    }
    
    // ✅ Fresh data bhi fetch karo - 800ms delay mobile ke liye
    const timer = setTimeout(() => {
        if (walletAddress) {
            getUserData();
        }
    }, 800);

    return () => clearTimeout(timer);
}, [walletAddress]);

    useEffect(() => {
            if (walletAddress && !dataFetchedRef.current) {
                getUserData();
                dataFetchedRef.current = true; 
            }
        }, [walletAddress]);

    useEffect(() => {
        if (window.ethereum) {
            const web3 = new Web3(window.ethereum);
            setWeb3Instance(web3);
        }
    }, []);

    return (
        <div className='dashcontainer'>
            <Grid container>
                <Grid item xs={12} md={12}>
                    <Appbar handleDrawerToggle={handleDrawerToggle} />
                </Grid>

                <Grid item xs={12} md={12}>
                    <Grid container spacing={2}>
                        <Grid item md={2}>
                            <Sidebar open={mobileOpen} handleDrawerToggle={handleDrawerToggle}
                                userId={userId}
                                setUserId={setUserId}
                                userData={userData}
                                setUserData={setUserData}
                                walletAddress={walletAddress}

                            />
                        </Grid>
                        <Grid item xs={12} md={10} sm={12} sx={{ mt: "70px" }}>
                            <Grid container spacing={3} p={3} >
                                <Grid item xs={12} md={12}>
                                    <Paper elevation={3} sx={{ backgroundColor: "#232529", color: "white", padding: "20px", borderRadius: "20px" }}>
                                        <Grid container spacing={1} sx={{ display: "flex", justifyContent: "center", flexDirection: "column", textAlign: "center" }}>
                                            <Grid item xs={12} md={12}>
                                                <div className='papercon'>
                                                    Refral Link
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={12} pb={2}>
                                                <div className='papersub'>
                                                    https://bnbconnect.io/Registration?id={walletAddress}
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={12} sx={{ display: "flex", justifyContent: "center" }}>

                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        border: "none",
                                                        color: "#fff",
                                                        fontSize: "16px",
                                                        fontWeight: 600,
                                                    }}
                                                    className='copybtn'
                                                    onClick={handleCopy}
                                                >
                                                    {copied ? "Copied!" : "Copy"}
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} md={12} mt={2}>
                                                <div className='papercon'>
                                                    My Address
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={12} pb={2}>
                                                <div className='papersub'>
                                                    {walletAddress}
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={12} >
                                                <div className='papersub'>
                                                    Sponsor Address
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <div className='papersub'>
                                                    {userData?.referral_address}
                                                </div>
                                            </Grid>
                                        </Grid>

                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        background: "linear-gradient(to right, #5596e0, #5284e0, #638fe3)",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(bccprice)}</div>
                                            <div className='cardtxt'>BCC Live Rate(BNB)</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        background: "linear-gradient(to right, #5596e0, #5284e0, #638fe3)",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{Number(liveRate).toFixed(6)} $</div>
                                            <div className='cardtxt'>BCC Live Rate(USDT)</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        background: "linear-gradient(to right, #5596e0, #5284e0, #638fe3)",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>
                                                {convertWeiToEther(bccsupply)}</div>
                                            <div className='cardtxt'>BCC Tocken Supply</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        background: "linear-gradient(to right, #5596e0, #5284e0, #638fe3)",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(token)}</div>
                                            <div className='cardtxt'>BCC Tocken Balance</div>
                                        </div>
                                    </Paper>
                                </Grid>

                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        backgroundColor: "#232529",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(liqudity)}</div>
                                            <div className='cardnumber'>BNB</div>
                                            <div className='cardtxt'>Liquidity</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        backgroundColor: "#232529",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(userData?.totalDeposit)}</div>
                                            <div className='cardnumber'>BNB</div>
                                            <div className='cardtxt'>Total Deposit</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        backgroundColor: "#232529",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(chiValue)}</div>
                                            <div className='cardnumber'>BNB</div>
                                            <div className='cardtxt'>Capping</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        backgroundColor: "#232529",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(userData?.level_income)}</div>
                                            <div className='cardnumber'>BNB</div>
                                            <div className='cardtxt'>Level Income</div>
                                        </div>
                                    </Paper>
                                </Grid>

                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        background: "linear-gradient(to right, #5596e0, #5284e0, #638fe3)",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(userData?.level_income)}</div>
                                            <div className='cardnumber'>BNB</div>
                                            <div className='cardtxt'>Total Income</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        background: "linear-gradient(to right, #5596e0, #5284e0, #638fe3)",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(userData?.totalSellBnb)}</div>
                                            <div className='cardnumber'>BNB</div>
                                            <div className='cardtxt'>Total Withdrawal</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        background: "linear-gradient(to right, #5596e0, #5284e0, #638fe3)",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(levelWallet)}</div>
                                            <div className='cardnumber'>BNB</div>
                                            <div className='cardtxt'>Level Income Wallet</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "100px",
                                        background: "linear-gradient(to right, #5596e0, #5284e0, #638fe3)",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(userData?.totalbnbcSell)}</div>
                                            <div className='cardnumber'>BNB</div>
                                            <div className='cardtxt'>Total Sell BCC</div>
                                        </div>
                                    </Paper>
                                </Grid>


                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "70px",
                                        backgroundColor: "#232529",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(userData?.directCount)}</div>
                                            <div className='cardtxt'>Direct Team</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "70px",
                                        backgroundColor: "#232529",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(userData?.directBusiness)} BNB</div>
                                            <div className='cardtxt'>Direct Business</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "70px",
                                        backgroundColor: "#232529",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{downlineTeam}</div>
                                            <div className='cardtxt'>Downline Team</div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} lg={3} md={4} sm={4}>
                                    <Paper elevation={2} sx={{
                                        p: 3,
                                        borderRadius: "20px",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        minHeight: "70px",
                                        backgroundColor: "#232529",
                                        textAlign: "center",
                                    }}>
                                        <div className='cardmain'>
                                            <div className='cardnumber'>{convertWeiToEther(downlineBusiness)} BNB</div>
                                            <div className='cardtxt'>Downline Business</div>
                                        </div>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>

                </Grid>
            </Grid>
        </div>
    )
}

export default Dashboard